import { OpenXmlPart } from './openXmlPart';
import { type CellRange, parseRefRange } from './utils';
import type { XlsxFile } from './xlsxFile';

export class TablePart extends OpenXmlPart {
  public range: CellRange;
  public displayName: string;

  constructor(filePath: string, originalXml: string, xlsxFile: XlsxFile) {
    super(filePath, originalXml, xlsxFile);

    const table = this.dom.getElementsByTagName('table')[0]!;
    this.range = parseRefRange(table.getAttribute('ref')!);
    this.displayName = table.getAttribute('displayName')!;
  }
}
